import { IOrderListItem } from '../../interfaces/IOrderLIstItem'
import MOrderListItem from '../../models/MOrderListItem'
import OrderPayments from '../../models/OrderPaymentItem'
import { getOrderDetail, getOrderPayments } from '../../util/orders/ordersAPIUtil'
import { IOrderPaymentItem } from '../../interfaces/IOrderPaymentItem'

export const RECEIVE_ORDER = '[Orders Detail] RECEIVE_ORDER'
export const RECEIVE_PAYMENTS = '[Orders Detail] RECEIVE_DETAIL'
export const IS_LOADING = '[Orders Detail] IS_LOADING_ORDER'
export const IS_ITEMS_LOADING = '[Orders Detail] IS_ITEMS_LOADING_ORDER'
export const FETCH_ERROR = '[Orders Detail] FETCH_ERROR'


export const receiveOrderDetail = (order: IOrderListItem) => ({
  type: RECEIVE_ORDER,
  payload: order,
})

export const receiveOrderPayments = (payments: IOrderPaymentItem[]) => ({
  type: RECEIVE_PAYMENTS,
  payload: payments,
})

export const sendFetchError = () => ({
  type: FETCH_ERROR,
})

export const isLoading = val => ({
  type: IS_LOADING,
  payload: val,
})

export const isItemsLoading = val => ({
  type: IS_ITEMS_LOADING,
  payload: val,
})

export const fetchOrderDetail = (orderId) => dispatch => {
  dispatch(isItemsLoading(true))
  return getOrderDetail(orderId)
    .then(res => {
      if (res.data?.data)
        dispatch(receiveOrderDetail(new MOrderListItem(res.data.data)))
    }).catch(error => {
      console.log('Fetch Status Error', error)
      dispatch(sendFetchError())
    }).finally(() => {
      dispatch(isLoading(false))
      dispatch(isItemsLoading(false))
    })
}

export const fetchOrderPayments = (orderId) => dispatch => getOrderPayments(orderId)
  .then(res => {
    if (res.data?.payments) {
      dispatch(receiveOrderPayments(res.data.payments.map(x => new OrderPayments(x))))
    }
  }).catch(error => {
    console.log('Fetch Status Error', error)
    dispatch(sendFetchError())
  }).finally(() => dispatch(isLoading(false)))

